module.exports = __webpack_public_path__ + "f68b5bad2f7992f823312acfcbb2a2e8.mp4";